module.exports = __webpack_public_path__ + "static/media/searchRed.ed1d65f4.svg";